import { useEffect } from "react";
import { motion, useMotionValue, useSpring, AnimatePresence } from "framer-motion";
import Video from "./Video";

// A video thumbnail that follows the cursor while a row is hovered.
export default function FloatingVideo({ src, vertical = false }) {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 200, damping: 22, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 200, damping: 22, mass: 0.5 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <AnimatePresence>
      {src && (
        <motion.div
          className="pointer-events-none fixed left-0 top-0 z-30 hidden md:block"
          style={{ x: sx, y: sy }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className={`-translate-x-1/2 -translate-y-1/2 overflow-hidden ring-1 ring-lav-400/60 shadow-[0_0_60px_-10px_rgba(167,139,250,0.5)] ${
              vertical ? "h-[46vh] w-[26vh]" : "h-[26vh] w-[42vh]"
            }`}
          >
            <Video src={src} priority className="h-full w-full" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
